import type { MouseEvent } from "react";

export const PROPERTY_FEATURED_FORM_ID = "property-featured-form";

const NAVBAR_OFFSET = 100;

export const scrollToPropertyFeaturedForm = (
  e?: MouseEvent<HTMLElement>,
) => {
  e?.preventDefault();

  const target = document.getElementById(PROPERTY_FEATURED_FORM_ID);
  if (!target) return;

  const top =
    target.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET;

  window.scrollTo({ top, behavior: "smooth" });
};
